import pako from "pako";
import type { PusherResponse } from "./types";

export const decompressValue = <Result>(value: string): PusherResponse<Result> => {
  const binaryData = atob(value);
  const characters = binaryData.split("").map((x) => x.charCodeAt(0));
  const byteArray = new Uint8Array(characters);
  let inflatedResponse = pako.inflate(byteArray, { to: "string" });
  try {
    inflatedResponse = JSON.parse(inflatedResponse);
  } catch (_) {
    // noop -- fails on straight string parsing while casting
    // arrays, objects, and numbers to proper types. Avoids having
    // to selectively compress attributes based on type.
  }
  return inflatedResponse as unknown as PusherResponse<Result>;
};
